/**
 * Serve correct size video based on screen size
 */
function serveCorrectSizeVideo() {
    if (typeof homepageVideo !== "undefined" && typeof player !== "undefined") {
        const playerVideo = jQuery('#player source');
        if (jQuery(window).width() > 1280) {
            playerVideo.attr('src', homepageVideo.main);
            player.load();
            player.play();
        } else if (jQuery(window).width() <= 1280 && jQuery(window).width() > 960) {
            playerVideo.attr('src', homepageVideo.twelve);
            player.load();
            player.play();
        } else if (jQuery(window).width() <= 960 && jQuery(window).width() > 640) {
            playerVideo.attr('src', homepageVideo.nine);
            player.load();
            player.play();
        } else if (jQuery(window).width() <= 640 && jQuery(window).width() > 400) {
            playerVideo.attr('src', homepageVideo.six);
            player.load();
            player.play();
        } else if (jQuery(window).width() <= 400) {
            playerVideo.attr('src', homepageVideo.four);
            player.load();
            player.play();
        }
    }
}

jQuery(document).ready(function($) {
    if (typeof homepageVideo !== "undefined") {
        const player = new Plyr('#player', {
            autoplay: true,
            volume: 0,
            muted: true,
            loop: {
                active: true,
            },
            storage: {
                enabled: false,
                key: 'plyr',
            },
            controls: [
                'play', // Play/pause playback
                'captions', // Toggle captions
            ],
        });
    }

    const plyr = $('.plyr');

    const width = $(window).width();
    const height = $(window).height();

    /**
     * Plyr video fit screen on load
     */
    if (plyr.height() > height) {
        if (width > 1024) {
            plyr.css({
                height,
                overflow: 'hidden',
            });
            $('.plyr__video-wrapper, #player').css({
                width: '100%',
                height: 'auto',
                display: 'flex',
                'align-items': 'center',
                margin: '0 auto',
            });
            $(window).resize(function() {
                plyr.css({
                    height: 'auto',
                });
            });
        } else {
            $('.plyr__video-wrapper, #player').css({
                margin: '0 auto',
            });
        }
    }

    /**
     * Serve correctly sized video on page load
     */
    serveCorrectSizeVideo();
    /**
     * Serve correctly sized video on page resize
     */
    let screenWidth = $(window).width();
    $(window).resize(function() {
        if (typeof homepageVideo !== "undefined" && typeof player !== "undefined") {

            const playerVideo = $('#player source');
            if ($(window).width() > 1280 && screenWidth <= 1280) {
                playerVideo.attr('src', homepageVideo.main);
                player.load();
                player.play();
                screenWidth = $(window).width();
            } else if ($(window).width() <= 1280 && $(window).width() > 960 && (screenWidth > 1280 || screenWidth <= 960)) {
                playerVideo.attr('src', homepageVideo.twelve);
                player.load();
                player.play();
                screenWidth = $(window).width();
            } else if ($(window).width() <= 960 && $(window).width() > 640 && (screenWidth > 960 || screenWidth <= 640)) {
                playerVideo.attr('src', homepageVideo.nine);
                player.load();
                player.play();
                screenWidth = $(window).width();
            } else if ($(window).width() <= 640 && $(window).width() > 400 && (screenWidth > 640 || screenWidth <= 400)) {
                playerVideo.attr('src', homepageVideo.six);
                player.load();
                player.play();
                screenWidth = $(window).width();
            } else if ($(window).width() <= 400 && screenWidth > 400) {
                playerVideo.attr('src', homepageVideo.four);
                player.load();
                player.play();
                screenWidth = $(window).width();
            }
        }
    });
});
